import React, { Component } from 'react';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
  error?: Error;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback || <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4" data-id="element-5699" data-mp="1a7wj2qmyc77l">
            <div className="text-center" data-id="element-5700" data-mp="156fh0rsqeepf">
              <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-5701" data-mp="2llgtycs5l0x1">
                Something went wrong
              </h1>
              <p className="text-gray-600 mb-4" data-id="element-5702" data-mp="2gmx8seldvt5q">
                We're sorry for the inconvenience. Please refresh the page.
              </p>
              <button onClick={() => window.location.reload()} className="bg-[#1E2B55] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#162041] transition-colors" data-id="element-5703" data-mp="2y6zymc6f5pq9">
                Refresh Page
              </button>
            </div>
          </div>;
    }
    return this.props.children;
  }
}